import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import swal2 from "sweetalert2";
import { FacturasService } from "src/app/services/service.index";
import * as XLSX from "xlsx";

interface FacturaCombinada {
  nombre: string;
  xml: File;
  pdf: File;
  notasCreditoXml: File[]; // archivos XML de nota
  notasCreditoPdf: File[]; // archivos PDF de nota
  notasBases: string[]; // nombres de los archivos combinados sin extension (para mostrar)
  totalOriginal?: number; // total leído del xml de la factura
  totalAjustado?: number; // total despues de aplicar notas restando los totales
  pendientesPdf?: File[];
  pendientesXml?: File[];
  erroresNotas?: string[];
}

@Component({
  selector: "app-altafacturasddnc",
  templateUrl: "./altafacturasddnc.component.html",
  styleUrls: ["./altafacturasddnc.component.css"],
})
export class AltafacturasddNcComponent implements OnInit {
  files = [];
  filesNames = [];
  filespdf = [];
  filesNamespdf = [];
  resulgood = [];
  resulbad = [];
  procesadasbien = 0;
  procesadasmal = 0;
  muestrareporte: boolean;
  facturasCombinadas: FacturaCombinada[] = [];

  myForm = new FormGroup({
    filesPdf: new FormControl(),
    filesXml: new FormControl(),
  });

  constructor(private facturas: FacturasService) {}

  ngOnInit() {
    this.resetVars();
  }

  resetVars() {
    this.myForm.reset();
    this.files = [];
    this.filesNames = [];
    this.filespdf = [];
    this.filesNamespdf = [];
    this.resulgood = [];
    this.resulbad = [];
    this.procesadasbien = 0;
    this.procesadasmal = 0;
    this.muestrareporte = false;
    this.facturasCombinadas = [];
    
  }

  formatoFechaexcel(fecha: string) {
    const a = new Date(fecha);
    a.setMinutes(a.getMinutes() + a.getTimezoneOffset());
    let montha = "" + (a.getMonth() + 1);
    let daya = "" + a.getDate();
    const yeara = a.getFullYear();
    if (montha.length < 2) montha = "0" + montha;
    if (daya.length < 2) daya = "0" + daya;
    return [yeara, montha, daya].join("-");
  }

  dragEnter(id: string) {
    const el = document.getElementById(id);
    if (el) el.style.border = "dashed 2px blue";
  }
  dragLeave(id: string) {
    const el = document.getElementById(id);
    if (el) el.style.border = "dashed 1px #979797";
  }
  drop(id: string) {
    const el = document.getElementById(id);
    if (el) el.style.border = "dashed 1px #979797";
  }

  async onFileChange(event) {
    // event is FileList
    for await (let num of event) {
      if (num.type && num.type.toLowerCase().includes("pdf")) {
        if (!this.filespdf.some((f) => f.name === num.name)) {
          this.filespdf.push(num);
          this.filesNamespdf.push(num.name);
        }
        this.filespdf.sort((a, b) => a.name.localeCompare(b.name));
        this.myForm.patchValue({ filesPdf: this.filespdf.slice() });
      } else if (num.type && num.type.toLowerCase().includes("xml")) {
        if (!this.files.some((f) => f.name === num.name)) {
          this.files.push(num);
          this.filesNames.push(num.name);
        }
        this.files.sort((a, b) => a.name.localeCompare(b.name));
        this.myForm.patchValue({ filesXml: this.files.slice() });
      }
    }
    await this.reconstruirCombinadas(); // reconstruir y leer totales
  }

  async reconstruirCombinadas() {
    const combinadas: FacturaCombinada[] = [];
    for (const xml of this.files) {
      const base = xml.name.replace(/\.xml$/i, "");
      const pdf = this.filespdf.find((p) => p.name.replace(/\.pdf$/i, "") === base);
      if (pdf) {
        const existed = this.facturasCombinadas.find((f) => f.nombre === base);
        if (existed) {
          existed.xml = xml;
          existed.pdf = pdf;
          combinadas.push(existed);
        } else {
          const f: FacturaCombinada = {
            nombre: base,
            xml,
            pdf,
            notasCreditoXml: [],
            notasCreditoPdf: [],
            notasBases: [],
            totalOriginal: undefined,
            totalAjustado: undefined,
            pendientesPdf: [],
            pendientesXml: [],
          };
          // extraer total original (async)
          try {
            const xmlDoc: any = await this.readFileXml(xml);
            const jsonxml = await this.xml2json(xmlDoc, "");
            const parsed = JSON.parse(jsonxml);
            const totalStr = this.getValues(parsed, "Total")[0];
            const totalNum = totalStr ? Number(totalStr) : 0;
            f.totalOriginal = isNaN(totalNum) ? 0 : totalNum;
            f.totalAjustado = f.totalOriginal;
          } catch (e) {
            f.totalOriginal = 0;
            f.totalAjustado = 0;
            console.warn("No se pudo leer total de factura:", base, e);
          }
          combinadas.push(f);
        }
      }
    }
    this.facturasCombinadas = combinadas;
    // aqui recalculo los totales por si ya existian facturas combinadas
    for (const fc of this.facturasCombinadas) this.actualizaNotasYCalculo(fc);
  }

  // Dropzone para las notas de credido
  abrirNotasCredito(factura: FacturaCombinada) {
    swal2.fire({
      title: "Agregar notas de crédito a " + factura.nombre,
      html:
        '<div class="dropzone-multi-nota" id="dropNotas" style="min-height:140px; padding:12px; border:dashed 1px #979797;">' +
        '<h5>NOTAS DE CRÉDITO</h5>' +
        '<p>Arrastra o busca tus archivos PDF y XML de notas aquí (deben coincidir por nombre base)</p>' +
        '<input accept=".pdf,.xml" type="file" id="inputNotas" multiple />' +
        '<div id="listaNotasModal" style="margin-top:10px; text-align:left;"></div>' +
        "</div>",
      showCancelButton: false,
      confirmButtonText: "Cerrar",
      cancelButtonText: "Cancelar",
      onOpen: () => {
        // elemento drop
        const drop = document.getElementById("dropNotas");
        const input = document.getElementById("inputNotas") as HTMLInputElement;
        const lista = document.getElementById("listaNotasModal");

        const highlight = () => {
          if (drop) drop.style.border = "dashed 2px blue";
        };
        const unhighlight = () => {
          if (drop) drop.style.border = "dashed 1px #979797";
        };

        if (drop) {
          drop.addEventListener("dragenter", (e) => {
            e.preventDefault();
            highlight();
          });
          drop.addEventListener("dragover", (e) => {
            e.preventDefault();
            highlight();
          });
          drop.addEventListener("dragleave", (e) => {
            e.preventDefault();
            unhighlight();
          });
          drop.addEventListener("drop", (e: any) => {
          e.preventDefault();
          unhighlight();

          const dt = e.dataTransfer;
          let files: File[] = [];

          // dt.files existe y tiene archivos
          if (dt.files && dt.files.length) {
            files = Array.prototype.slice.call(dt.files);
          }
        
          // dt.items existe me fallo en chrome y agregue esto
          else if (dt.items && dt.items.length) {
            for (let i = 0; i < dt.items.length; i++) {
              const item = dt.items[i];
              if (item.kind === "file") {
                const file = item.getAsFile();
                if (file) {
                  files.push(file);
                }
              }
            }
          }
        
          // si no hay archivo no hace nada
          if (!files.length) return;
        
          // llamamos la funcion
          this.handleNotasFiles(files, factura, lista);
          });
        }
        if (input) {
          input.addEventListener("change", (ev: any) => {
            const files = Array.prototype.slice.call(ev.target.files || []);
            if (files && files.length) {
              this.handleNotasFiles(files, factura, lista);
            }
            // limpiar input para permitir re-subir mismos nombres si se desea
            (ev.target as HTMLInputElement).value = "";
          });
        }
        // mostrar lista actual al abrir
        this.mostrarListaNotasEnModal(factura, lista);
      },
    }).then((result) => {
      // al cerrar guardamos porque ya estan en la factura
    });
  }


  // aqui manejo los archivos seleccionados o los que son arrastradis en el modal
  async handleNotasFiles(files: File[], factura: FacturaCombinada, listaEl?: HTMLElement) {

  if (!factura.pendientesPdf) factura.pendientesPdf = [];
  if (!factura.pendientesXml) factura.pendientesXml = [];

  for (const f of files) {
    const name = f.name.toLowerCase();

    const base = name.replace(/\.pdf$/i, "").replace(/\.xml$/i, "");

    const esPdf = name.endsWith(".pdf") || (f.type && f.type.includes("pdf"));
    const esXml = name.endsWith(".xml") || (f.type && f.type.includes("xml"));

    // -------- manejo PDF --------
    if (esPdf) {
      // verifico si pdf esta en pendientes
      const xmlPendiente = factura.pendientesXml.find(x =>
        x.name.toLowerCase().replace(/\.xml$/, "") === base
      );

      if (xmlPendiente) {
        // ya hay pareja, formo el par
        factura.notasCreditoPdf.push(f);
        factura.notasCreditoXml.push(xmlPendiente);

        // quito el xml de pendiente
        factura.pendientesXml = factura.pendientesXml.filter(x => x !== xmlPendiente);
      } else {
        // aun no existe el xml, lo paso a pendiente
        if (!factura.pendientesPdf.some(p => p.name === f.name)) {
          factura.pendientesPdf.push(f);
        }
      }
    }

    // -------- manejo XML --------
    else if (esXml) {
      // verifico si existe el xml en pendientes
      const pdfPendiente = factura.pendientesPdf.find(x =>
        x.name.toLowerCase().replace(/\.pdf$/, "") === base
      );

      if (pdfPendiente) {
        //si encuentro la pareja formo el par
        factura.notasCreditoPdf.push(pdfPendiente);
        factura.notasCreditoXml.push(f);

        // quito pdf de pendiente
        factura.pendientesPdf = factura.pendientesPdf.filter(x => x !== pdfPendiente);
      } else {
        // au no existe pdf, lo paso a pendiente
        if (!factura.pendientesXml.some(x => x.name === f.name)) {
          factura.pendientesXml.push(f);
        }
      }
    }
  }

  // recalculo totales
  await this.actualizaNotasYCalculo(factura);

  // refresco modal si es que aplica
  if (listaEl) this.mostrarListaNotasEnModal(factura, listaEl);
}

    mostrarListaNotasEnModal(factura: FacturaCombinada, listaEl: HTMLElement) {
  if (!listaEl) return;

  // reconstruir html con 2 secciones
  const bases = factura.notasBases || [];
  const errores = factura.erroresNotas || [];

  let html = "<div>";

  // NOTAS VALIDAS
  html += "<div><strong>Notas válidas</strong>";
  if (!bases.length) {
    html += "<div><em>No hay notas válidas (pares XML+PDF)</em></div>";
  } else {
    html += "<ul style='list-style:none;padding-left:0;margin:0;'>";
    for (const b of bases) {
      html += `<li style="margin-bottom:6px;">
        <button data-base="${b}" class="btn-eliminar-nota btn btn-sm btn-outline-danger" style="margin-left:8px;">Eliminar</button>
        &nbsp;<strong>${b}</strong>
      </li>`;
    }
    html += "</ul>";
  }
  html += "</div>";

  // ERRORES
  html += "<div style='margin-top:8px;'>";
  html += "<strong style='color:#c0392b;'>Notas con error</strong>";
  if (!errores.length) {
    html += "<div><em>No hay notas con error</em></div>";
  } else {
    html += "<ul style='list-style:none;padding-left:0;margin:0;color:#c0392b;'>";
    for (let i = 0; i < errores.length; i++) {
      const err = errores[i];
      // extraemos una 'base' si viene entre comillas para poder eliminar; si no, usamos índice
      const match = err.match(/\"(.+?)\"/);
      const base = match ? match[1].replace(/\.xml$/i, "") : `err${i}`;
      html += `<li style="margin-bottom:6px;">
        <button data-base="${base}" class="btn-eliminar-error btn btn-sm btn-outline-danger" style="margin-left:8px;">Eliminar</button>
        &nbsp; ${err}
      </li>`;
    }
    html += "</ul>";
  }
  html += "</div>";

  html += "</div>";

  listaEl.innerHTML = html;

  // attach listeners for eliminar (notas válidas)
  const btns = listaEl.querySelectorAll(".btn-eliminar-nota");
  btns.forEach((btn: Element) => {
    btn.addEventListener("click", (ev: any) => {
      const base = btn.getAttribute("data-base");
      if (base) {
        this.eliminarNotaPorBase(factura, base);
        // refrescar lista
        this.mostrarListaNotasEnModal(factura, listaEl);
      }
    });
  });

  // attach listeners for eliminar (errores)
  const btnsErr = listaEl.querySelectorAll(".btn-eliminar-error");
  btnsErr.forEach((btn: Element) => {
    btn.addEventListener("click", (ev: any) => {
      const base = btn.getAttribute("data-base");
      if (base) {
        this.eliminarNotaError(factura, base);
        this.mostrarListaNotasEnModal(factura, listaEl);
      }
    });
  });
}

eliminarNotaError(factura: FacturaCombinada, base: string) {
  // eliminar archivos (si quedaron en pendientes)
  factura.notasCreditoXml = (factura.notasCreditoXml || []).filter(
    x => x.name.replace(/\.xml$/i, "") !== base
  );
  factura.notasCreditoPdf = (factura.notasCreditoPdf || []).filter(
    p => p.name.replace(/\.pdf$/i, "") !== base
  );
  factura.pendientesPdf = (factura.pendientesPdf || []).filter(
    p => p.name.replace(/\.pdf$/i, "") !== base
  );
  factura.pendientesXml = (factura.pendientesXml || []).filter(
    x => x.name.replace(/\.xml$/i, "") !== base
  );

  // eliminar mensaje de erroresNotas que incluya esa base
  factura.erroresNotas = (factura.erroresNotas || []).filter(err => {
    // si el mensaje contiene "base" lo quitamos
    return !err.toLowerCase().includes(base.toLowerCase());
  });

  // recalcular totales
  this.actualizaNotasYCalculo(factura);
}




  // Devuelve nombres base que tengan los dos xml+pdf
  getNotasBases(factura: FacturaCombinada): string[] {
    const xmlBases = factura.notasCreditoXml.map((f) => f.name.replace(/\.xml$/i, ""));
    const pdfBases = factura.notasCreditoPdf.map((f) => f.name.replace(/\.pdf$/i, ""));
    // intersection
    const intersection = xmlBases.filter((b) => pdfBases.indexOf(b) !== -1);
    // unique
    const uniq: string[] = [];
    for (const i of intersection) if (uniq.indexOf(i) === -1) uniq.push(i);
    return uniq;
  }


  // aqui elimino las notas del nombre base
  eliminarNotaPorBase(factura: FacturaCombinada, base: string) {
    factura.notasCreditoXml = factura.notasCreditoXml.filter((f) => f.name.replace(/\.xml$/i, "") !== base);
    factura.notasCreditoPdf = factura.notasCreditoPdf.filter((f) => f.name.replace(/\.pdf$/i, "") !== base);
    // recalcular
    this.actualizaNotasYCalculo(factura);
  }

async actualizaNotasYCalculo(factura: FacturaCombinada) {
  // inicializar errores
  factura.erroresNotas = factura.erroresNotas || [];

  // recalcular nombres base válidos (intersección actual)
  factura.notasBases = this.getNotasBases(factura);

  let sumaNotas = 0;
  const basesValidas: string[] = []; // las que sí parsearon

  for (const base of factura.notasBases) {
    const notaXml = factura.notasCreditoXml.find(
      x => x.name.replace(/\.xml$/i, "") === base
    );

    // si no hay xml, no puede ser válida (aunque esto normalmente no pasa)
    if (!notaXml) continue;

    try {
      const notaXmlDoc: any = await this.readFileXml(notaXml);
      const notaJson = await this.xml2json(notaXmlDoc, "");
      const notaParsed = JSON.parse(notaJson);

      const totalNotaStr = this.getValues(notaParsed, "Total")[0];
      const totalNota = totalNotaStr ? Number(totalNotaStr) : 0;

      if (!isNaN(totalNota)) {
        sumaNotas += totalNota;
      }
      basesValidas.push(base);
    } catch (e) {
      // XML inválido: registrar mensaje de error para mostrar en modal
      factura.erroresNotas.push(`La nota "${notaXml.name}" no tiene un XML válido y será descartada.`);

      // eliminar ambos archivos (xml y pdf) de las listas para que NO sean tomadas en cuenta
      factura.notasCreditoXml = factura.notasCreditoXml.filter(
        x => x.name.replace(/\.xml$/i, "") !== base
      );
      factura.notasCreditoPdf = factura.notasCreditoPdf.filter(
        p => p.name.replace(/\.pdf$/i, "") !== base
      );

      // también si por alguna razón estaban en pendientes, eliminarlos
      if (factura.pendientesPdf) {
        factura.pendientesPdf = factura.pendientesPdf.filter(p => p.name.replace(/\.pdf$/i, "") !== base);
      }
      if (factura.pendientesXml) {
        factura.pendientesXml = factura.pendientesXml.filter(x => x.name.replace(/\.xml$/i, "") !== base);
      }
      // NOTA: no hacemos continue explícito, pasamos al siguiente base
    }
  }

  // reasignar notasBases únicamente a las que quedaron válidas
  factura.notasBases = basesValidas;

  // ajustar total usando sólo las notas válidas
  const orig = factura.totalOriginal !== undefined ? factura.totalOriginal : 0;
  factura.totalAjustado = Number((orig - sumaNotas).toFixed(2));
  if (isNaN(factura.totalAjustado)) factura.totalAjustado = 0;
}



  // INTENTO DE ELIMINAR LA NOTA DESDE LA TABLA (EN PROCESO O NO)
  eliminarNotaArchivo(factura: FacturaCombinada, fileName: string) {
    factura.notasCreditoPdf = factura.notasCreditoPdf.filter((f) => f.name !== fileName);
    factura.notasCreditoXml = factura.notasCreditoXml.filter((f) => f.name !== fileName);
    this.actualizaNotasYCalculo(factura);
  }

  /** ---------- PROCESO PRINCIPAL ---------- */
async procesarfacturas() {
    swal2.fire({ title: "Procesando, espere por favor", allowOutsideClick: false });
    swal2.showLoading();
    this.procesadasbien = 0;
    this.procesadasmal = 0;
    this.resulgood = [];
    this.resulbad = [];

    if (!this.facturasCombinadas.length) {
      swal2.fire("Debe arrastrar al menos un PDF y un XML", "", "info");
      return;
    }

    const fechaactual = this.formatoFechaexcel(new Date().toString());

    for (const factura of this.facturasCombinadas) {
      const urlsSubidas: string[] = [];
      let falloFactura = false;

      try {
        // Aqui ya traigo el total original y ajustado en caso de que hubiera
        // lo vuelvo a parsear porque necesite mas campos (o no xD)
        const xmlDoc: any = await this.readFileXml(factura.xml);
        const jsonxml = await this.xml2json(xmlDoc, "");
        const parsed = JSON.parse(jsonxml);

        const data: any = {
          emitter_rfc: parsed["cfdi:Emisor"] ? parsed["cfdi:Emisor"].Rfc : parsed["cfdi:Comprobante"] && parsed["cfdi:Comprobante"]["cfdi:Emisor"] ? parsed["cfdi:Comprobante"]["cfdi:Emisor"].Rfc : undefined,
          receiver_rfc: parsed["cfdi:Receptor"] ? parsed["cfdi:Receptor"].Rfc : parsed["cfdi:Comprobante"] && parsed["cfdi:Comprobante"]["cfdi:Receptor"] ? parsed["cfdi:Comprobante"]["cfdi:Receptor"].Rfc : undefined,
          invoice_folio: this.getValues(parsed, "Folio")[0],
          invoice_date: this.formatoFechaexcel(this.getValues(parsed, "Fecha")[0]),
          currency: this.getValues(parsed, "Moneda")[0],
          cfdi_usage: parsed["cfdi:Receptor"] ? parsed["cfdi:Receptor"].UsoCFDI : parsed["cfdi:Comprobante"] && parsed["cfdi:Comprobante"]["cfdi:Receptor"] ? parsed["cfdi:Comprobante"]["cfdi:Receptor"].UsoCFDI : undefined,
          total: factura.totalAjustado !== undefined ? factura.totalAjustado : this.getValues(parsed, "Total")[0],
          xml: "",
          uuid: (parsed["cfdi:Complemento"] && parsed["cfdi:Complemento"]["tfd:TimbreFiscalDigital"]) ? parsed["cfdi:Complemento"]["tfd:TimbreFiscalDigital"].UUID : undefined,
          invoice_serie: this.getValues(parsed, "Serie")[0],
          document_type: this.getValues(parsed, "TipoDeComprobante")[0],
          pdf: "",
          entry_date: fechaactual,
          status: "PENDIENTE",
          credit_notes_pdf: [],
          credit_notes_xml: []
        };

        if (data.currency === "MXN") data.currency = "PESOS";
        if (data.document_type === "I") data.document_type = "Ingresos";

        if (Number(data.total) <= 0) {
          this.procesadasmal++;
          this.resulbad.push({
            status: false,
            resp: { error: { errors: ["El total de la factura no puede ser 0 o menor"] } },
            msg: "El total de la factura no puede ser 0 o menor",
            nombre: factura.nombre,
          });
          continue;
        }
        // si hay notas con error y no fueron eliminadas -> NO procesar esta factura
        if (factura.erroresNotas && factura.erroresNotas.length) {
          this.procesadasmal++;
          this.resulbad.push({
            status: false,
            resp: { error: { errors: ["La factura tiene notas de crédito con XML inválido. Elimine o corrija las notas antes de procesar."] } },
            msg: "Error: notas de crédito inválidas",
            nombre: factura.nombre
          });
          continue; // saltar esta factura
        }
       // ---- SUBIR NOTAS DE CRÉDITO Y GUARDAR URLs ----
        data.credit_notes_pdf = [];
        data.credit_notes_xml = [];
              
        // validar que existan pares
      if (factura.notasCreditoPdf.length && factura.notasCreditoXml.length) {
      
        for (let i = 0; i < factura.notasCreditoPdf.length; i++) {
        
          const pdf = factura.notasCreditoPdf[i];
          const xml = factura.notasCreditoXml[i];
        
          // subir PDF nota
          const respPdfNota = await this.retry(
            () => this.callupload(pdf, data.uuid + "_nota_pdf_" + i),
            3
          );
        
          if (!respPdfNota.status) {
            falloFactura = true;
            this.procesadasmal++;
            this.resulbad.push({
              status: false,
              resp: { error: { errors: ["Error al subir PDF de nota de crédito"] } },
              msg: "Error al subir PDF de nota",
              nombre: factura.nombre,
            });
            break; // NO seguir subiendo notas
          }
        
          urlsSubidas.push(respPdfNota.resp.url);
          data.credit_notes_pdf.push({ url: respPdfNota.resp.url });

          // subir XML nota
          const respXmlNota = await this.retry(
            () => this.callupload(xml, data.uuid + "_nota_xml_" + i),
            3
          );
        
          if (!respXmlNota.status) {
            falloFactura = true;
            this.procesadasmal++;
            this.resulbad.push({
              status: false,
              resp: { error: { errors: ["Error al subir XML de nota de crédito"] } },
              msg: "Error al subir XML de nota",
              nombre: factura.nombre,
            });
            break;
          }
        
          urlsSubidas.push(respXmlNota.resp.url);
          data.credit_notes_xml.push({ url: respXmlNota.resp.url });
        }
      
        //  limpiar bucket si falló alguna nota
        if (falloFactura) {
          for (const url of urlsSubidas) {
            await this.borraArchivoBucket(url);
          }
          continue; // NO subir factura ni llamar subefactura
        }
      }

        const respPdf = await this.retry(() => this.callupload(factura.pdf, data.uuid), 3);
        const respXml = await this.retry(() => this.callupload(factura.xml, data.uuid), 3);

        if (!respPdf.status || !respXml.status) {
        
          // guardar urls que sí alcanzaron a subirse
          if (respPdf.status) urlsSubidas.push(respPdf.resp.url);
          if (respXml.status) urlsSubidas.push(respXml.resp.url);
        
          // borrar TODO (notas + factura)
          for (const url of urlsSubidas) {
            await this.borraArchivoBucket(url);
          }
        
          this.procesadasmal++;
          this.resulbad.push({
            status: false,
            resp: { error: { errors: ["Error al subir archivo PDF o XML"] } },
            msg: "Error al subir archivo PDF o XML",
            nombre: factura.nombre,
          });
        
          continue;
        }

        data.pdf = respPdf.resp.url;
        data.xml = respXml.resp.url;

        urlsSubidas.push(respPdf.resp.url);
        urlsSubidas.push(respXml.resp.url);

        const response = await this.retry(() => this.subefactura(data, factura.nombre), 3);
        if (response.msg === "OK") {
          this.procesadasbien++;
          this.resulgood.push(response);
        } else {
        
          // borrar notas + pdf + xml
          for (const url of urlsSubidas) {
            await this.borraArchivoBucket(url);
          }
        
          this.procesadasmal++;
          this.resulbad.push(response);
        }

      } catch (error) {
        this.procesadasmal++;
        this.resulbad.push({
          status: true,
          resp: { error: { errors: ["Xml no tiene el formato correcto"] } },
          msg: "Error",
          nombre: factura.nombre,
        });
      }
    }

    this.muestrareporte = true;
    swal2.close();
  }

  /* ---------- todo lo del parseo y subidas esta aca abajo ---------- */

  async retry(fn, retries) {
    for (let i = 0; i < retries; i++) {
      try {
        return await fn();
      } catch (error) {
        if (i === retries - 1) throw error;
        await new Promise((r) => setTimeout(r, 1000));
      }
    }
  }

  async callupload(file, name) {
    try {
      // mi servicio retorna un observable por eso lo pongo como promise si no o jala
      const r = await this.facturas.uploadFileSBDD(file, name).toPromise();
      return { status: true, resp: r };
    } catch (e) {
      return { status: false, resp: e };
    }
  }

  async subefactura(data, name) {
    try {
      const r = await this.facturas.guardaFacturaDDDD(data).toPromise();
      return { msg: "OK", resp: r, nombre: name };
    } catch (e) {
      return { msg: "Error", resp: e, nombre: name };
    }
  }

  // readFileXml -> devuelve promesa que resuelve en document
  async readFileXml(file: File): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const text = reader.result ? reader.result.toString() : "";
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, "application/xml");
          const errorNode = doc.querySelector("parsererror");
          if (errorNode) reject("Error al parsear XML");
          else resolve(doc);
        } catch (err) {
          reject(err);
        }
      };
      reader.onerror = (err) => reject(err);
      reader.readAsText(file, "UTF-8");
    });
  }

  // xml2json: version que encontre para mejorar el parseo
  async xml2json(xml, tab) {
    //genera un objeto y lo hace stringify
    var X = {
      toObj: function (xmlNode) {
        var o = {};
        if (xmlNode.nodeType === 1) {
          // attributes
          if (xmlNode.attributes && xmlNode.attributes.length) {
            for (var i = 0; i < xmlNode.attributes.length; i++) {
              o[xmlNode.attributes[i].nodeName] = xmlNode.attributes[i].nodeValue || "";
            }
          }
          // children
          if (xmlNode.childNodes && xmlNode.childNodes.length) {
            for (var j = 0; j < xmlNode.childNodes.length; j++) {
              var item = xmlNode.childNodes[j];
              if (item.nodeType === 1) {
                var nodeName = item.nodeName;
                var childObj = X.toObj(item);
                if (o[nodeName]) {
                  if (!(o[nodeName] instanceof Array)) o[nodeName] = [o[nodeName]];
                  o[nodeName].push(childObj);
                } else {
                  o[nodeName] = childObj;
                }
              } else if (item.nodeType === 3) {
                // text
                if (item.nodeValue && item.nodeValue.trim()) {
                  o["#text"] = (o["#text"] || "") + item.nodeValue.trim();
                }
              }
            }
          }
        } else if (xmlNode.nodeType === 9) {
          o = X.toObj(xmlNode.documentElement);
        }
        return o;
      },
    };
    if (xml.nodeType === 9) xml = xml.documentElement;
    return JSON.stringify(X.toObj(xml));
  }

  getValues(obj: any, key: string) {
    const vals: any[] = [];
    for (const i in obj) {
      if (!obj.hasOwnProperty(i)) continue;
      if (typeof obj[i] === "object") {
        const childVals = this.getValues(obj[i], key);
        for (let j = 0; j < childVals.length; j++) vals.push(childVals[j]);
      } else if (i === key) vals.push(obj[i]);
    }
    return vals;
  }

  exportexcelcorrectasdd() {
    const element = document.getElementById("facturasCorrectas");
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "facturascorrectas.xlsx");
  }

  exportexcelerroresdd() {
    const element = document.getElementById("facturasErrores");
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "facturaserrores.xlsx");
  }
  //de ultimo momento, para eliminar la factura porque no jalaba
 /* eliminarFactura(factura) {
  this.facturasCombinadas = this.facturasCombinadas.filter(
    f => f.nombre !== factura.nombre
  );
  console.log(this.facturasCombinadas)
}*/

private convertToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = (reader.result as string)
        .replace(/^data:[a-zA-Z\/]+;base64,/, '');
      resolve(base64String);
    };
    reader.onerror = (error) => reject(error);
  });
}

    async borraArchivoBucket(url: string) {
    try {
      // mi servicio retorna un observable por eso lo pongo como promise si no o jala
      const r = await this.facturas.borraFacturaBucket(url).toPromise();
      return { status: true, resp: r };
    } catch (e) {
      return { status: false, resp: e };
    }
    }

  eliminarFactura(factura) {
  const base = factura.nombre;
  // eliminar XML
  this.files = this.files.filter(
    f => f.name.replace(/\.xml$/i, "") !== base
  );
  // eliminar PDF
  this.filespdf = this.filespdf.filter(
    f => f.name.replace(/\.pdf$/i, "") !== base
  );
  // eliminar de combinadas
  this.facturasCombinadas = this.facturasCombinadas.filter(
    f => f.nombre !== base
  );
  console.log("Facturas combinadas:", this.facturasCombinadas);
}


}